import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { Observable, of } from 'rxjs';

@Component({
    selector: 'aa-delete-item',
    templateUrl: './delete-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteItemComponent
{
    @Input() asyncTrashable: Observable<boolean> = of(false);
    @Input() trashable: boolean = false;
    @Input() title: string = 'Delete this item';
    @Input() label: string = undefined;
    @Output() cta: EventEmitter<string> = new EventEmitter<any>();

    onClick (event: any): void
    {
        if (this.cta)
        {
            this.cta.emit(event);
        }
    }
}
